import { ResultSet } from "@cubejs-client/core";
import { AppThunk } from "appThunk";
import { DateTime } from "luxon";
import { cubeProductQueryFilterHelper } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

import { Operator } from "modules/customer/tools/product/operator";
import { Partner } from "modules/customer/tools/product/partner";
import { Store } from "modules/customer/tools/product/store";
import { Range } from "modules/customer/tools/product/storeRangeFilters/range";

export const loadCategoryTotalSales = (
    referenceDate: DateTime,
    selectedPartner?: Partner,
    selectedRange?: Range,
    selectedStore?: Store,
    selectedOperator?: Operator
): AppThunk<Promise<number>> => async (dispatch) => {
    try {
        if (!selectedPartner || !selectedRange) {
            return 0;
        }

        const startDate = referenceDate.minus({ months: 12 }).plus({ days: 1 }).startOf('day');
        const endDate = referenceDate.endOf('day');
        const query = {
            measures: [
                "ProductSalesEstimate.SumEstimatedSales",
            ],
            timeDimensions: [{
                dimension: "D_Date.Date",
                dateRange: [startDate, endDate]
            }],
            filters: [{
                member: "D_ProductCategory.ProductCategory1",
                operator: "equals",
                values: [String(selectedRange.productCategory)]
            }],
            segments: [
                "D_Store.OpenPhysicalStores"
            ]
        };

        const resultSet = await dispatch(
            cubeProductQueryFilterHelper(query, selectedOperator, selectedPartner, selectedStore, undefined)
        ) as unknown as ResultSet;
        const sales = Number(resultSet.rawData()[0]["ProductSalesEstimate.SumEstimatedSales"] ?? 0);
        return sales;
    } catch (error) {
        dispatch(logError("Error loading CategoryTotalSales.", error));
        throw error;
    }
};
